/* eslint-disable no-param-reassign */
import { GRID_CHECKBOX_SELECTION_COL_DEF } from '@mui/x-data-grid'
import { createDataGridSlice } from '../generic/createDataGridSlice'
import { INVOICE_PAGINATION } from '../../settings/constants/pagination'

const { INITIAL_PAGE, ROWS_PER_PAGE } = INVOICE_PAGINATION

const getInitialState = () => ({
  pagination: {
    page: INITIAL_PAGE,
    pageSize: ROWS_PER_PAGE,
  },
  columns: {
    columnVisibilityModel: {},
  },
  pinnedColumns: {
    left: [GRID_CHECKBOX_SELECTION_COL_DEF.field],
    right: ['actions'],
  },
  selectionModel: [],
})

export const createManualInvoiceSlice = createDataGridSlice({
  name: 'createManualInvoice',
  initialState: getInitialState(),
  reducers: {
    resetCreateManualInvoicesState: () => {
      return getInitialState()
    },
  },
})

export const {
  setPage: setCreateManualInvoicesPage,
  setPageSize: setCreateManualInvoicesPageSize,
  setColumnVisibilityModel: setCreateManualInvoicesColumnVisibilityModel,
  setPinnedColumns: setCreateManualInvoicesPinnedColumns,
  setSelectionModel: setCreateManualInvoicesSelectionModel,
  resetCreateManualInvoicesState,
} = createManualInvoiceSlice.actions

export default createManualInvoiceSlice.reducer
